import axios from 'axios';
import { config } from '../../config';

const FORBIDDEN_MESSAGE = "You don't have permission to make changes in this workspace.";

const v2ApiClient = axios.create({
  baseURL: config.backend,
  headers: {
    'Content-Type': 'application/json',
  },
  validateStatus: (status) => (status >= 200 && status < 300) || status === 207,
});

v2ApiClient.interceptors.request.use((requestConfig) => {
  const nextConfig = requestConfig;
  const token = localStorage.getItem('ids_token');
  const orgId = localStorage.getItem('ids_org_id');

  if (token) {
    nextConfig.headers.Authorization = `Bearer ${token}`;
  }

  const isDiscoveryPost =
    typeof nextConfig.url === 'string' &&
    nextConfig.url.startsWith('/discovery/') &&
    (nextConfig.method || 'get').toLowerCase() === 'post';

  if (isDiscoveryPost && orgId) {
    if (nextConfig.data instanceof FormData) {
      if (!nextConfig.data.has('org_id')) {
        nextConfig.data.append('org_id', orgId);
      }
    } else if (nextConfig.data && typeof nextConfig.data === 'object' && !('org_id' in nextConfig.data)) {
      nextConfig.data = { ...nextConfig.data, org_id: orgId };
    }
  }

  return nextConfig;
});

/**
 * Response interceptor — handles 401 Unauthorized globally.
 * Clears auth state and redirects to login via the existing autoLogout event
 * so AutoLogoutListener (which has Router context) performs the navigation.
 */
v2ApiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      window.dispatchEvent(new CustomEvent('autoLogout'));
    }
    // Screens toast error.message; replace axios's generic "Request failed with status code 403"
    // (e.g. a view-only shared-workspace user attempting an edit) with a readable message.
    if (error.response && error.response.status === 403) {
      error.message = FORBIDDEN_MESSAGE;
    }
    return Promise.reject(error);
  }
);

export default v2ApiClient;
